  $(document).ready(function(){


      $(".gift-collection-grid .grid__item").each(function(){
        var addcarttext=$(this).find(".flatbtn a.add-to-cart span").text();
        
        $(this).find("a.add-to-cart").text(addcarttext+" - " + $(this).find(".product-price__price").text());
      })
   
     $('.slider-review-parent').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:true,
  infinite:true,
       dots:true
});
     $('.main-parent-block-insta').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  infinite:false,
       dots:true,
  responsive: [
  {
    breakpoint: 1366,
      settings: {
      slidesToShow: 3
      }
  },
    {
    breakpoint: 992,
      settings: {
      slidesToShow: 2
      }
  },
    {
    breakpoint: 577,
      settings: {
      slidesToShow: 1
      }
  }
  ]
});
     $('.landing-page-first-collection.first-coll-responsive-slider .grid-products').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:false,
  infinite:false,
       dots:false,
  responsive: [
  {
    breakpoint: 1366,
      settings: {
      slidesToShow: 3
      }
  },
    {
    breakpoint: 750,
      settings: {
      slidesToShow: 1,
        dots:true,
        centerMode:true,
         infinite:true
        
      }
  },
    {
    breakpoint: 577,
      settings: {
      slidesToShow: 1,
        dots:true,
        centerMode:true,
         infinite:true
        
      }
  }
  ]
});
    $('.landing-page-first-collection.sea-food-slider .grid-products').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  infinite:false,
       dots:false,
  responsive: [
  {
    breakpoint: 1366,
      settings: {
      slidesToShow: 3
      }
  },
    {
    breakpoint: 992,
      settings: {
      slidesToShow: 2
       
        
        
      }
  },
    {
    breakpoint: 749,
      settings: {
      slidesToShow: 1.55
        
        
      }
  }
  ]
});

    $('.landing-page-first-collection.gift-collection-grid .grid-products').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows:false,
  infinite:false,
       dots:false,
  responsive: [
  {
    breakpoint: 1366,
      settings: {
      slidesToShow: 3
      }
  },
     {
    breakpoint: 992,
      settings: {
      slidesToShow: 2
      }
  },
    {
    breakpoint: 750,
      settings: {
      slidesToShow: 2,
        dots:true,
        centerMode:true,
         infinite:true
        
      }
  },
    {
    breakpoint: 577,
      settings: {
      slidesToShow: 1,
        dots:true,
        centerMode:true,
         infinite:true
        
      }
  }
  ]
});
setTimeout(function(){
   $(".pop-up-link-img.left-img-popup li").first().click();
  $(".pop-up-link-img.right-img-popup li:nth-child(2)").click();
  },1000);
    
     $(document).on("click", ".read-more-con", function() {
      if($(this).text() == "Read less"){
     $(this).parents(".single-data-popup").find(".large-content-pop").hide();
      $(this).parents(".single-data-popup").find(".small-content-pop").show();    
      $(this).text("Read more");
      }
      else{
        $(this).parents(".single-data-popup").find(".large-content-pop").show();
      $(this).parents(".single-data-popup").find(".small-content-pop").hide();
     
      $(this).text("Read less");
      }
    });
  $(document).on("click", ".single-block-head", function() {
    $(".single-block-head").not(this).removeClass("active");
       $(this).toggleClass("active").next().slideToggle();
        $(".single-block-desc").not($(this).next()).slideUp(300);
   
});
$(document).on("click", ".dropdown-with-data li", function() {
   var firstlist=$(this).attr("data-first-point");
    var secondlist=$(this).attr("data-second-point");
    var thirdlist=$(this).attr("data-third-point");

  $(".dropdown-hide-show").slideUp();
    $(".drop-down-popup").removeClass("active");
$(this).parents(".pop-up-link-img").find(".btn-link a").attr("href",$(this).attr("data-btn-link"));
  
  $(this).parents(".pop-up-link-img").find(".top-img-popup img").attr("src",$(this).attr("data-img-src"));
  $(this).parents(".dropdown-with-data").find(".drop-down-popup span").text($(this).text());
  if($(this).parents(".pop-up-link-img").hasClass("left-img-popup")){
  $(".all-data-content-bottom .single-data-popup").each(function(){
    
    
   $(this).find('.svg-left-pop.svg-list-1 svg').show();
    $(this).find('.svg-left-pop.svg-list-1 svg:gt(' + (firstlist - 1) + ')').hide();

    
   $(this).find('.svg-left-pop.svg-list-2 svg').show();
    $(this).find('.svg-left-pop.svg-list-2 svg:gt(' + (secondlist - 1) + ')').hide();

    
   $(this).find('.svg-left-pop.svg-list-3 svg').show();
    $(this).find('.svg-left-pop.svg-list-3 svg:gt(' + (thirdlist - 1) + ')').hide();

  
});
  }
  else{
    $(".all-data-content-bottom .single-data-popup").each(function(){
    
    
   $(this).find('.svg-right-pop.svg-list-1 svg').show();
    $(this).find('.svg-right-pop.svg-list-1 svg:gt(' + (firstlist - 1) + ')').hide();

    
   $(this).find('.svg-right-pop.svg-list-2 svg').show();
    $(this).find('.svg-right-pop.svg-list-2 svg:gt(' + (secondlist - 1) + ')').hide();

    
   $(this).find('.svg-right-pop.svg-list-3 svg').show();
    $(this).find('.svg-right-pop.svg-list-3 svg:gt(' + (thirdlist - 1) + ')').hide();

  
});
  }
   
  });
  $(document).on("click", ".drop-down-popup", function() {
   
    $(this).parent().find(".dropdown-hide-show").slideToggle();
    $(this).toggleClass("active");
  });
    $(document).on("click", ".heading-pop svg", function() {
   $(".pop-up-main-parent").addClass("hide-pop");
      $(".pop-up-main-parent").removeClass("active-pop");
      $("html").removeClass("hide-overflow");
    });
    $(document).on("click", function (event) {
    if (!$(event.target).closest(".main-page-width-pop-up").length) {
      if($(".pop-up-main-parent").hasClass("active-pop")){
      $(".pop-up-main-parent").addClass("hide-pop");
      $(".pop-up-main-parent").removeClass("active-pop");
        $("html").removeClass("hide-overflow");
      }
    }
  });
    $(document).on("click", ".compare-open", function() {
      setTimeout(function(){
   $(".pop-up-main-parent").removeClass("hide-pop");
      $(".pop-up-main-parent").addClass("active-pop");
        $("html").addClass("hide-overflow");
        },300);
    });



     
    
     $('.landing-page-first-collection.second-coll-responsive-slider.gift-collection-grid .grid-view-item__link').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:true,
  infinite:true,
       dots:false,
       draggable: false,
        swipe: false,
        responsive: [
  {
    breakpoint: 750,
      settings: {
      draggable: false,
        swipe: false,

      }
  }
          ]
       
});
  });